const categories = [
    {
        slug: 'head',
        title: 'Head'
    },
    {
        slug: 'thorax',
        title: 'Thorax'
    },
    {
        slug: 'abdomen',
        title: 'Abdomen'
    }
]

Vue.component('state-shop', {
    data: function() {
        let token = Cookies.get('token');
        token = null;
        if (token) {
            axios.get(API_URL + '/inventory?token=' + token).then((res) => {
                let inventory = res.data;
                axios.get(API_URL + '/settings?token=' + token).then((settingsRes) => {
                    this.settings = settingsRes && settingsRes.data ? settingsRes.data.settings : {};
                    this.equippedData = settingsRes && settingsRes.data ? settingsRes.data.equippedData : {};

                    for (let i=0; i<this.categories.length; i++) {
                        let cat = this.categories[i];
                        if (this.equippedData[cat.slug]) {
                            this.updateItem(this.equippedData[cat.slug]);
                        }
                    }

                    this.inventorySlugs = [];
                    for (let i = 0; i < inventory.length; i++) {
                        let sku = inventory[i];
                        this.inventorySlugs.push(sku.skuSlug);
                    }
                    this.loading = false;
                });
            });
        }
        return {
            loading: !!token,
            categories: categories,
            settings: {},
            equippedData: {},
            inventorySlugs: [],
            currentShopCategory: null,
            currentCategoryData: {},
            currentUser: game.services.user.currentUser
        };
    },
    methods: {
        changeShopCategory: function(category) {
            this.loading = true;
            this.currentShopCategory = category;
            for (let i=0; i<this.categories.length; i++) {
                let cat = this.categories[i];
                if (cat.slug === category) {
                    this.currentCategoryData = cat;
                    break;
                }
            }

            axios.get(API_URL + '/shop/' + this.currentShopCategory).then((res) => {
                this.currentCategoryData.items = res.data;
                this.currentCategoryData.items.unshift({
                    slug: undefined,
                    name: 'None',
                    price: 0
                });
                for (let i=0; i<this.currentCategoryData.items.length; i++) {
                    let item = this.currentCategoryData.items[i];
                    this.updateItem(item);
                }

                this.loading = false;
            }, () => {
                this.loading = false;
                game.showGrowl('Failed to load shop.', {type: 'danger'});
            });
        },
        updateItem: function(item) {
            let width = 75;
            let height = 75;
            let offsetx = 0;
            let offsety = 0;
            let size = 'contain';
            let backgroundColor = null;
            if (item.data) {
                if (item.data.shop.width) {
                    width = item.data.shop.width;
                }
                if (item.data.shop.height) {
                    height = item.data.shop.height;
                }
                if (item.data.shop.offsetx) {
                    offsetx = -item.data.shop.offsetx;
                }
                if (item.data.shop.offsety) {
                    offsety = -item.data.shop.offsety;
                }
                if (item.data.shop.size) {
                    size = item.data.shop.size;
                }
                if (item.data.shop.background) {
                    backgroundColor = item.data.shop.background;
                }
            }
            item.style = {
                margin: '5px',
                marginLeft: 'auto',
                marginRight: 'auto',
                width: width + 'px',
                height: height + 'px',
                transform: 'scale(1.2)',
                maxWidth: '75px',
                maxHeight: '75px',
                backgroundSize: size
            };
            if (item.data) {
                item.style.background = 'url(\'' + item.data.shop.image + '\') ' + offsetx + 'px ' + offsety + 'px';
            }
            if (backgroundColor) {
                item.style.backgroundColor = backgroundColor;
            }

            item.canEquip = item.price === 0 || this.inventorySlugs.includes(item.slug);
        },
        equipItem: function(item) {
            $('#loading-overlay').show();
            this.settings[this.currentShopCategory] = item.slug;

            let token = Cookies.get('token');
            axios.post(API_URL + '/settings?token=' + token, this.settings).then(() => {
                this.updateItem(item);
                this.equippedData[this.currentShopCategory] = item;
                this.$forceUpdate();
                $('#loading-overlay').hide();

                if (window.ga) {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Lobby',
                        eventAction: 'equipItem',
                        eventLabel: item.slug
                    });
                }
            });
        },
        buyItem: function(item) {
            $('#loading-overlay').show();
            let token = Cookies.get('token');
            axios.post(API_URL + '/buyItem?token=' + token, {
                slug: item.slug
            }).then((res) => {
                if (res.data.success) {
                    this.inventorySlugs.push(item.slug);
                    this.currentUser.coinCount -= item.price;
                    this.equipItem(item);

                    if (window.ga) {
                        ga('send', {
                            hitType: 'event',
                            eventCategory: 'Lobby',
                            eventAction: 'buyItem',
                            eventLabel: item.slug
                        });
                    }

                    game.showGrowl('Item purchased!', {type: 'success'});
                } else {
                    game.showGrowl(res.data.message, {type: 'danger'});
                    $('#loading-overlay').hide();

                    if (res.data.message === 'Not enough funds.') {
                        //TODO: Show coin purchasing.
                    }
                }
            });
        },
        signIn: function() {
            this.$root.$emit('changeState', 'state-signin');
        }
    },
    template: `
    <div class="vertical-center">
        <h1><i class="fa fa-shopping-basket fa-2x"></i></h1>
        <h3>The shop will be coming back in a later update.</h3>
    </div>
    `
    /*
    template: `
    <div class="vertical-center">
        <div v-if="loading">
            <h1><i class="fa fa-refresh fa-spin fa-2x"></i></h1>
        </div>
        <div v-if="!currentUser && !loading">
            <h1><i class="fa fa-shopping-basket fa-2x"></i></h1>
            <h3>Sign in to view the shop.</h3>
            <button type="button" class="app-btn app-btn-secondary" v-on:click="signIn()"><i class="fa fa-sign-in"></i> Sign In</button>
        </div>
        <div v-if="currentUser && !loading">
            <br><br><br>
            <h2 title="Coins">
                <img class="icon" src="assets/money_icon.png">{{currentUser.coinCount}}
            </h2>
            <div v-if="!currentShopCategory">
                <div class="row">
                    <div class="col" v-for="(category, index) in categories">
                        <h4>{{category.title}}</h4>
                        <div class="app-card app-card-clickable shop-item" v-on:click="changeShopCategory(category.slug)">
                            <div v-if="!equippedData[category.slug]">
                                <div style="height:60px;">None</div>
                            </div>
                            <div v-if="equippedData[category.slug]">
                                <div style="height:60px;">{{equippedData[category.slug].name}}</div>
                                <div style="width:75px; height:75px; margin-left:auto; margin-right:auto;">
                                    <div v-bind:style="equippedData[category.slug].style"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="currentShopCategory">
                <button type="button" class="app-btn app-btn-sm app-btn-danger" v-on:click="currentShopCategory=null">
                    <i class="fa fa-arrow-left"></i> Return
                </button>
                <br><br>
                <div v-for="(item, index) in currentCategoryData.items" class="app-card shop-item">
                    <div style="height:60px;">{{item.name}}</div>
                    <div style="width:75px; height:75px; margin-left:auto; margin-right:auto;">
                        <div v-bind:style="item.style"></div>
                    </div>
                    <br>
                    <button v-if="!item.canEquip" type="button" style="white-space:nowrap;" class="app-btn app-btn-primary app-btn-sm" v-on:click="buyItem(item)">
                        Buy {{item.price}} <img class="icon-sm" src="assets/money_icon.png">
                    </button>
                    <button v-if="item.canEquip && settings[currentShopCategory] !== item.slug" type="button" style="white-space:nowrap;" class="app-btn app-btn-secondary app-btn-sm" v-on:click="equipItem(item)">
                        Equip
                    </button>
                    <button v-if="item.canEquip && settings[currentShopCategory] === item.slug" type="button" style="white-space:nowrap;" class="app-btn app-btn-secondary app-btn-sm">
                        Equipped
                    </button>
                </div>
            </div>
        </div>
        <br><br>
    </div>
    `
    */
})